/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Evolink_Video_QualityInputs */

const en_admin_settings_fields_evolink_video_quality = /** @type {(inputs: Admin_Settings_Fields_Evolink_Video_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MiniMax H3 Max Turbo resolution`)
};

/**
* | output |
* | --- |
* | "MiniMax H3 Max Turbo resolution" |
*
* @param {Admin_Settings_Fields_Evolink_Video_QualityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_evolink_video_quality = /** @type {((inputs?: Admin_Settings_Fields_Evolink_Video_QualityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Evolink_Video_QualityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_evolink_video_quality(inputs)
});
export { admin_settings_fields_evolink_video_quality as "admin.settings.fields.evolink_video_quality" }